/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { TaskVariablesResponseVariables } from './taskVariablesResponseVariables';

/**
 * ``GET /tasks/{task_id}/variables`` response.
 *
 * A ``{key: value}`` map of every V1 template variable resolved
 * against the task's live candidate / sender / job context. The task
 * side-panel editors insert these values as literal text at click
 * time (a hand-executed task body must never ship unresolved
 * ``{{variable}}`` chips). Missing data resolves to ``null``.
 */
export interface TaskVariablesResponse {
  variables?: TaskVariablesResponseVariables;
}
